module.exports = __webpack_public_path__ + "img/xinsheng.ae00fb65.png";